export default {
  PRODUCT_LIST: 'product_list',
  PRODUCT_DETAILS: 'product_details'
};
